import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/App'

export const startCourseBilling = data => {
  const root = createRoot(document.getElementById('course_billing'))
  root.render(<App coursenum={data.coursenum} initialBillingRecord={data.billing_record} />)
}
